export default __webpack_public_path__ + "assets/img_realestate_xl-b2809289.png";